export const properties = {
  disabled: 'Disabled',
  visible: 'Visibility',
  highlighted: 'Highlight',
  triggerInfo: 'Trigger state',
  infoValue: 'Trigger value',
  hideLabel: 'Hide label',
  subStep: 'Sub-step',
  tooltips: {
    disabled: 'Specifies whether the step is disabled by default',
    visible: 'Specifies whether the step should be visible by default',
    highlighted: 'Specifies whether the step should be highlighted by default',
    triggerInfo: 'Determines whether the trigger should be active by default',
    infoValue: 'Text inside the trigger',
    hideLabel: 'Hides the element label',
    subStep: 'Sub-step settings',
  },
  saveSuccess: 'Property has been updated',
} as const
